__turbopack_context__.v({
  "acronym": "Coin-module-scss-module__FVgOTq__acronym",
  "coin": "Coin-module-scss-module__FVgOTq__coin",
  "fullName": "Coin-module-scss-module__FVgOTq__fullName",
  "icon": "Coin-module-scss-module__FVgOTq__icon",
  "inFront": "Coin-module-scss-module__FVgOTq__inFront",
  "name": "Coin-module-scss-module__FVgOTq__name",
  "smallGap": "Coin-module-scss-module__FVgOTq__smallGap",
});
